export default __webpack_public_path__ + "static/media/icon_Cosmos_white.fc75717a.svg";